import { PagedApiResponse, Tag } from "types";

import API from "api/client";
import { envConfig } from "config";

const { tagsAPI } = envConfig;

type TagSearchProps = {
  query?: string;
  page?: number;
  size?: number;
};

/**
 * Search tags with pagination.
 */
const searchTags = async ({ query, page = 1, size = 10 }: TagSearchProps) => {
  return API.get<PagedApiResponse<Tag>>(`${tagsAPI}`, { params: { query, page, size } }).then((res) => res.data);
};

/**
 * Get all tags for an account.
 */
const getAllTags = async () => {
  return API.get<Tag[]>(`${tagsAPI}all`).then((res) => res.data);
};

export default {
  search: searchTags,
  getAll: getAllTags,
};
